import React from "react";

// Renders a plain string and bolds any case-insensitive "coming soon" occurrence.
// Preserves surrounding whitespace/punctuation exactly.
export function withBoldComingSoon(text) {
  if (!text) return text;
  const parts = text.split(/(coming soon)/gi);
  return parts.map((part, i) =>
    /^coming soon$/i.test(part) ? (
      <strong key={i} className="font-bold">
        {part}
      </strong>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}
